<template>
	<Page>
		<div class="centered">
			<Breadcrumb :crumbs="[
				{
					text : 'Templates',
					to : {name:'templates'},
				},
				{
					text : template.name,
					to : {name:'template',params:{template_id:template.id}},
				},
			]" />
			<div class="TopWithActions">
				<div class="main">
					<h1>{{ template.name }}</h1>
				</div>
				<div class="actions">
					<!-- <button :class="{'btn-warning':1,'_btn_submitting':deleting}" @click="deleteTemplate" ><i class="fa fa-trash-alt"></i></button> -->
				</div>
			</div>
			<TemplateNav :template="template" />
			<router-view :template="template" @update="onUpdateTemplate" ></router-view>
		</div>
	</Page>
</template>

<script>

	import Page from '../mixins/Page'
	import TemplateNav from '../components/TemplateNav'
	import Breadcrumb from '../components/Breadcrumb'

	var loaded_template = null;

	function formatTemplateData(template){
		return {
				...template,
				templateData : {
					body:template.template,
					variables:template.variables,
				}
			};
	}

	export default {
		mixins : [Page],

		components : {
			TemplateNav,
			Breadcrumb,
		},

		data(){
			return {
				deleting : false,
				template : loaded_template,
			}
		},

		beforeRouteEnter(to, from, next){
			api.get('template',to.params.template_id)
				.then((template)=>{
					loaded_template = formatTemplateData(template);
					next();
				});
		},

		methods:{
			onUpdateTemplate(template){
				this.template = formatTemplateData(template);
			},
			deleteTemplate(){
				var self = this;

				if(!confirm('Are you sure you want to permanently delete this template?')) return false;

				self.deleting = true;

				return api.delete('template',self.template.id).then(function(template){
					self.$router.push({name:'templates'});
				}).catch(function(e){
					alert(e.message || 'Failed to delete template. Try again.');
				}).then(function(){
					self.deleting = false;
				});
			},
		}

	}

</script>